<template>
  <div>
    <page-header :actions="pageActionConfig" :page="pageConfig" />
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <filter-manager
          v-model="filtersSelected"
          :display-advanced="false"
          :filters="filterManagerConfig"
          @search="onSearchHandler"
        />
      </div>
    </div>
    <separator class="mt-4 mb-5" text="Resultados" />

    <result-not-found v-if="!showNotFound" />

    <template v-else>
      <board class="mb-4" :details="boardData" />
      <div
        v-if="result.data && result.data.length > 0"
        class="col d-flex justify-content-end align-items-center mb-2"
      >
        <custom-link
          class="justify-content-end font-14"
          icon="fa fa-plus"
          text="Expandir Todos"
          @click="checkUncheckHandler(true)"
        />
        <custom-link
          class="justify-content-end font-14 ml-3"
          icon="fa fa-minus"
          text="Colapsar Todos"
          @click="checkUncheckHandler(false)"
        />
      </div>
      <callout
        v-for="(resultItem, idx) in result.data"
        :key="idx"
        border-color="primary-15"
        class="mb-3 callout__extended"
        :controlled="true"
        :has-toggle="true"
        :opened="resultItem.isOpen"
        @click:open="onOpenDetails(resultItem)"
      >
        <div class="row pb-0 mb-0">
          <div class="col-sm-12 col-md-2 d-md-flex rounded">
            <div class="d-flex align-items-center">
              <icon-view
                class="icon-view__extended"
                icon="fas fa-user-shield"
                icon-background="#fff"
                icon-color="#FF7058"
                icon-size="14px"
              />
            </div>

            <div class="d-flex flex-column justify-content-center">
              <span class="font-14 color-secondary-6">Número de PEI:</span>
              <div class="color-black font-16 font-weight-bold">
                {{
                  resultItem.peiId.slice(0, 4) +
                    '-' +
                    resultItem.peiId.slice(4, 10)
                }}
              </div>
            </div>
          </div>
          <div class="col-sm d-flex flex-column justify-content-center">
            <span class="font-14 color-secondary-6">Enmienda:</span>
            <div class="color-black font-16 font-weight-bold">
              {{ resultItem.generalRevisionNo.toString().padStart(2, '0') }}
            </div>
          </div>
          <div class="col-sm d-flex flex-column justify-content-center">
            <span class="font-14 color-secondary-6">
              Año Escolar Extendido:
            </span>
            <div class="color-black font-16 font-weight-bold">
              {{
                resultItem.configExtendedSchoolYearFlag === '1' ? 'Si' : 'No'
              }}
            </div>
          </div>
          <div
            class="col-sm border-right d-flex flex-column justify-content-center pr-0 my-2"
          >
            <span class="font-14 color-secondary-6">Fecha de Firma:</span>
            <div class="color-black font-16 font-weight-bold">
              {{ resultItem.generalClosedDate | date }}
            </div>
          </div>
          <div class="col-sm pl-4 d-flex flex-column justify-content-center">
            <span class="font-14 color-secondary-6">Fecha de Inicio:</span>
            <div class="color-black font-16 font-weight-bold">
              {{ resultItem.serviceAnalysisPlacementStartDate | date }}
            </div>
          </div>
          <div
            class="col-sm-3 d-flex justify-content-center align-items-center"
          >
            <action-button
              i="fas fa-print"
              variant="outline-success"
              @click="onDownloadPeiReport(resultItem.peiId)"
            >
              Reporte del PEI o PS
            </action-button>
          </div>
        </div>

        <template #edition>
          <div class="container-fluid p-2">
            <div class="container-fluid bg-white">
              <div class="mx-1">
                <div class="row py-2 d-sm-none d-md-flex border-edition-header">
                  <div class="col">
                    <span>Servicio / Modalidad</span>
                  </div>
                  <div class="col">
                    <span>Frecuencia / Duración</span>
                  </div>
                  <div class="col">
                    <span>Transportación</span>
                  </div>
                  <div class="col">
                    <span>Acción</span>
                  </div>
                </div>
                <div
                  v-for="(item, itemIdx) in resultItem.items"
                  :key="itemIdx"
                  class="row pt-1"
                  :class="{
                    'border-bottom': itemIdx != resultItem.items.length - 1,
                  }"
                >
                  <div class="col-sm d-flex align-items-center pb-1">
                    <div>
                      <span>{{ item.disciplineName }}</span>
                      <div
                        v-show="item.serviceModalityTypeName"
                        class="font-14 color-secondary-6 font-weight-normal"
                      >
                        {{ item.serviceModalityTypeName }}
                      </div>
                    </div>
                  </div>
                  <div class="col-sm d-flex align-items-center pb-1">
                    <div>
                      <span>{{ item.frequencyTypeName }}</span>
                      <div
                        v-show="item.durationTypeName"
                        class="font-14 color-secondary-6 font-weight-normal"
                      >
                        {{ item.durationTypeName }}
                      </div>
                    </div>
                  </div>
                  <div class="col-sm d-flex align-items-center pb-1">
                    <transportation-type
                      v-if="isBECA(item.peiTransportationName)"
                      :companion-flag="item.companionFlag"
                      :mileage="item.mileage"
                      :pei-transportation-name="item.peiTransportationName"
                      :service-daily-cost="item.serviceDailyCost"
                    />
                    <div v-else>
                      {{ transportationMode(item.peiTransportationName) }}
                    </div>
                  </div>
                  <div class="col-sm d-flex align-items-center">
                    <action-button
                      v-if="enableMileageAction(item.peiTransportationCode)"
                      i="fas fa-file-search"
                      variant="outline-success"
                      @click="
                        onDownloadMileageHandler(
                          item.peiId,
                          item.analysisServiceId
                        )
                      "
                    >
                      Ver Acuerdo/Millaje
                    </action-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </callout>
    </template>
  </div>
</template>

<script>
import FilterManager from 'FilterManager';
import Separator from 'custom-separator';
import ResultNotFound from 'custom-result-not-found';
import IconView from 'icon-view';
import TransportationType from './components/TransportationType.vue';
import CustomLink from '@/shared/components/CustomLink.vue';
import {
  getAllYearsForLoadProcess as _getAllYearsForLoadProcess,
  getStudentPeiData as _getStudentPeiData,
  getTransportationReport as _getTransportationReport,
} from '@/modules/shared/scholarship.api.js';
import peiTransportationCodes from '@/utils/constants/peiTransportationCodes.js';
import _generalApi from '@/modules/app/api';
import mixWait from 'utils/mixins/loading';
import alertMixin from 'utils/mixins/alert.mixin.js';

export default {
  name: 'PeiInformation',
  components: {
    FilterManager,
    Separator,
    IconView,
    TransportationType,
    ResultNotFound,
    CustomLink,
  },
  mixins: [mixWait, alertMixin],
  data() {
    return {
      filtersSelected: {},
      board: {},
      catalog: {
        academicYears: [],
      },
      result: {},
      displayResults: false,
    };
  },
  computed: {
    enableMileageAction() {
      return (code) => code == peiTransportationCodes.BECA;
    },
    showNotFound() {
      return this.displayResults;
    },
    pageConfig() {
      return {
        icon: 'fas fa-car',
        title: 'Información de PEI',
        routes: [
          'Inicio',
          'Becas',
          'Manejo de Pago Estudiante Elegibles',
          'Ver Información de PEI',
          'Información de PEI',
        ],
      };
    },
    pageActionConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-left',
          variant: 'outline-success',
          click: this.onReturn,
        },
      ];
    },
    filterManagerConfig() {
      return [
        {
          component: 'CustomDropDown',
          name: 'academicYear',
          options: this.catalog.academicYears,
          placeholder: 'Seleccione el Año',
          fieldKey: 'id',
          class: 'col-sm-12 col-md-6',
          fieldName: 'name',
          clearable: false,
        },
        {
          component: 'CustomInput',
          name: 'ssnosie',
          placeholder: 'Escribe SSN o SIE',
          icon: 'fa fa-search color-orange',
          leftIcon: true,
          maskType: 'SieOrSSN',
          validations: 'required',
          error: 'El SIE o SSN es requerido.',
        },
      ];
    },
    boardData() {
      return [
        [
          {
            label: 'SIE:',
            icon: 'fas fa-address-book',
            data: this.result.studentSieId,
          },
          {
            label: 'Estudiante:',
            icon: 'fas fa-address-book',
            data: this.result.studentFullName,
          },
          {
            label: 'Región:',
            icon: 'fas fa-map-marker-alt',
            data: this.result.region,
          },
          {
            label: 'Estatus del Estudiante:',
            icon: 'fas fa-ballot-check',
            data: this.result.status,
          },
          {
            label: 'Impedimento:',
            icon: 'fas fa-ballot-check',
            data: this.result.studentImpediment,
          },
        ],
      ];
    },
    isBECA() {
      return (value) => value === 'BECA';
    },
    transportationMode() {
      return (value) => (value ? value : 'No es Necesario');
    },
  },
  mounted() {
    this.callGetInitFilters();
  },
  methods: {
    async callGetInitFilters() {
      const { data } = await _getAllYearsForLoadProcess();
      this.catalog = {
        academicYears: data,
      };
      this.filtersSelected = {
        ...this.filtersSelected,
        academicYear: data[0],
      };

      if (this.$route.params.ssnosie != null) {
        this.filtersSelected = {
          ssnosie: this.$route.params.ssnosie,
          academicYear: this.$route.params.academicYear,
        };
        this.onSearchHandler();
      }
    },

    async onSearchHandler() {
      if (!this.filtersSelected.ssnosie || this.filtersSelected.ssnosie == '') {
        this.ShowToast(
          'Error de Validación',
          'Favor completar la información solicitada para poder continuar.',
          'error'
        );
        return;
      }

      this.ShowWait();
      const payload = {
        academicYearId: Number(this.filtersSelected.academicYear?.id) ?? null,
        searchText: this.filtersSelected.ssnosie,
      };

      await _getStudentPeiData(payload)
        .then((response) => {
          this.HideWait();
          this.result = response.data;
          this.displayResults = this.result.data.length > 0;
        })
        .catch(() => {
          this.HideWait();
          this.result = {};
          this.displayResults = false;
        });
    },
    async onDownloadMileageHandler(peiId, serviceId) {
      await _getTransportationReport(peiId, serviceId).then((response) => {
        _generalApi.ConvertToBlob(response.data);
      });
    },
    onReturn() {
      this.$router.push('/sholarship/paymentmanagement');
    },
    onOpenDetails(item) {
      item.isOpen = !item.isOpen;
      this.$forceUpdate();
    },
    checkUncheckHandler(isOpen) {
      this.result = {
        ...this.result,
        data: this.result.data.map((item) => ({
          ...item,
          isOpen: isOpen,
        })),
      };
    },
    async onDownloadPeiReport(peiId) {
      await _generalApi.getReportsPEIPS(peiId);
    },
  },
};
</script>

<style lang="scss" scoped>
.border-edition-header {
  border-bottom: 2px #ff7058 solid;
}

.icon-view__extended ::v-deep {
  .dot {
    em {
      margin-top: -2px !important;
      margin-left: 2px !important;
    }
  }
}

.callout__extended ::v-deep {
  .bg-secondary-3 {
    .row-container > {
      .col.p-2.ml-2 {
        padding: 0px !important;
      }
    }
  }
}
</style>
